<template>
  <div class="container">
    <div class="shop_list" ref="wrapper">
      <div v-for="(item,index) in regDictFormList" :key="index"  class="main">
            <div class="inpBox" v-if="item.regType == 1">
               <span class="inpBox_title">{{item.regName}}</span>
               <input type="text" class="inpBox1_text "  @blur="blur" @input="changeVal(index)"  :placeholder="'请输入' + item.regName"  v-model="item.regValue"/>
               <div class="content_1_line"></div>
            </div>
            <div class="inpBox"  v-if="item.regType == 2">
               <span class="inpBox_title">{{item.regName}}</span>
               <div class="butn_box_row1">
                  <span  :class="['border',radioIndex == 0 ? 'butn_radio' : 'activeRadio']" @click="changeRadioSex(index,0)">男</span>
                  <span  :class="['border',radioIndex==1 ? 'butn_radio' : 'activeRadio']" @click="changeRadioSex(index,1)">女</span>
               </div>
            </div>
            <div class="inpBox" v-if="item.regType == 3"  >
               <span class="inpBox_title">{{item.regName}}</span>
               <div class="butn_box_row" @click="selectFun(item.sortOrder)">
                  <span :class="['butn_name1',item.regValue?'butn_name':'']">{{item.regValue?item.regValue:'请选择'+item.regName}}</span>
               </div>
               <div class="content_1_line"></div>
            </div>
        </div>
        <yd-datetime style="display:none;"  ref="datetime" @input="dateChange" type="date" v-model="date" start-date="1919-01-01"></yd-datetime>
    </div>
    <common-footer class="button">
      <mt-button v-if="allHasVal" :class="['btn_bm','btn_color_'+common.theme]" @click="goToPost">下一步</mt-button>
      <mt-button v-else class="btn_bm_gray" @click="goToPost">下一步</mt-button>
    </common-footer>
  </div>
</template>

<script>
import {
  getRegDictFromByActId,
  insertActiviteRegistration
} from '../../utils/api';
import util from '../../utils/util';
import Scroll from '../../components/scroll';
import commonFooter from '../../components/commonFooter';
import { mapState } from 'vuex';
export default {
  name: 'activityForm',
  components: {
    commonFooter,
    Scroll
  },
  computed: {
    ...mapState({
      common: state => state.common,
      userInfo: state => state.common.userInfo,
      openId: state => state.common.openId,
      userId: state => state.common.userId,
      marketInfo: state => state.common.marketInfo
    })
  },
  data () {
    return {
      date: util.formatTime(new Date(), 4),
      peopleNum: 1,
      isShowButton: true,
      radioIndex: 0,
      result: '',
      selectOrder: '',
      pickerValue: new Date(),
      regDictFormList: '',
      allHasVal: false,
      orderId: '123345566',
      weexParam: '',
      testIndex: 222,
      activeID: '',
      isFree: '',
      actPrice: 0,
      datetime0: '',
      sortOrder: ''
    };
  },
  activated () {
    if (this.activeID !== this.$route.params.id) {
      this.activeID = this.$route.params.id;
      this.getRegDictFromByActIdAction();
    }
  },
  methods: {
    blur(){
      setTimeout(function(){
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    selectFun (sortOrder) {
      this.sortOrder = sortOrder;
      this.$refs.datetime.open();
    },
    dateChange (val) {
      if (this.regDictFormList) {
        this.regDictFormList.forEach(item => {
          if (item.sortOrder === this.sortOrder) {
            item.regValue = val
            item.isOk = true
          }
        })
      }
      for (var i = 0; i < this.regDictFormList.length; i++) {
        if (this.regDictFormList[i].isOk) {
          this.allHasVal = true;
        } else {
          this.allHasVal = false;
          break;
        }
      }
    },
    changeRadioSex (index, value) {
      this.radioIndex = value;
      this.regDictFormList[index].regValue = +'' + value + '';
    },
    formatTen (num) {
      return num > 9 ? num + '' : '0' + num;
    },
    formatDate (date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      // var hour = date.getHours();
      // var minute = date.getMinutes();
      // var second = date.getSeconds();
      return year + '-' + this.formatTen(month) + '-' + this.formatTen(day);
    },

    getRegDictFromByActIdAction () {
      let params = {
        actId: this.activeID
      };
      getRegDictFromByActId(params, {
        cityId: this.marketInfo.cityId,
        userId: this.userId,
        openId: this.openId,
        marketId: this.marketInfo.id
      }).then(res => {
        console.log(res)
        if ((res.res.code === 10000 || res.res.code === '10000') && res.body) {
          if (res.body.regDictFormList) {
            var regDictFormList = res.body.regDictFormList;
            this.result = regDictFormList;
            if (
              regDictFormList.length === 1 &&
              regDictFormList[0].regKey === 'dict_gender'
            ) {
              this.allHasVal = true;
            }
            for (var i = 0; i < regDictFormList.length; i++) {
              regDictFormList[i].regValue = '';
              regDictFormList[i].warnMessage = '';
              regDictFormList[i].isOk = false;

              if (regDictFormList[i].regKey === 'dict_gender') {
                regDictFormList[i].regValue = '0';
                regDictFormList[i].isOk = true;
              }
            }

            this.regDictFormList = regDictFormList;
          } else {
            // toast.showErrorMessage('暂无数据');
          }
        } else {
          // toast.showMessage(ret.res.msg);
        }
      });
    },

    changeVal: function (index) {
      var order = index;
      var item = this.regDictFormList[order];
      var myreg = item.regularName;

      var str = this.regDictFormList[order].regValue;
      if (str.trim().length) {
        this.regDictFormList[order].warnMessage = '';
        this.regDictFormList[order].isOk = true;
      } else {
        this.regDictFormList[order].isOk = false;
      }

      if (myreg && myreg !== '0') {
        // myreg 0 不需要验证正则
        myreg = myreg.replace('/', '');
        myreg = myreg.replace('/', '');
        var re = new RegExp(myreg);
        if (!re.test(this.regDictFormList[order].regValue)) {
          this.regDictFormList[order].isOk = false;
        }
      }

      for (var i = 0; i < this.regDictFormList.length; i++) {
        if (this.regDictFormList[i].isOk) {
          this.allHasVal = true;
        } else {
          this.allHasVal = false;
          break;
        }
      }
    },

    goToPost () {
      console.log(this.regDictFormList)
      if (!this.allHasVal) {
        for (var i = 0; i < this.regDictFormList.length; i++) {
          if (!this.regDictFormList[i].isOk) {
            var str = '请输入正确的' + this.regDictFormList[i].regName;
            util.showToast(str);
            break;
          }
        }
        return;
      }
      for (let i = 0; i < this.regDictFormList.length; i++) {
        if (this.regDictFormList[i].warnMessage != '') {
          util.showToast(this.regDictFormList[i].warnMessage);
          return;
        }
      }
      this.insertActiviteRegistrationAction();
    },

    insertActiviteRegistrationAction () {
      // toast.showLoadingMessage("报名中...")
      let params = {
        actId: this.activeID,
        userId: this.userId,
        userName: this.userInfo.name || this.userInfo.userName || '没有用户名',
        phone: this.userInfo.phone || this.userInfo.account,
        marketId: this.marketInfo.id,
        regList: this.regDictFormList
      };
      insertActiviteRegistration(params, {
        cityId: this.marketInfo.cityId,
        userId: this.userId,
        openId: this.openId,
        marketId: this.marketInfo.id
      }).then(res => {
        if (!res.res) {
          return;
        }
        if (res.res.code === 10000 && res.body) {
          if (res.body.orderId) {
            this.orderId = res.body.orderId;
            if (res.body.type === 1) {
              // 报名成功提示
              this.$router.push({
                path: `/activitySuccess`
              });

              // this.addIntegration()
              // configObj.jump('views/successView/index.js', '?succText=' + encodeURI('报名成功！') + '&descText=' + encodeURI('已成功报名活动，欢迎您的到来') +
              // '&navigatorText=' + encodeURI('查看订单') + '&pageUrl=' + encodeURI('views/myOrder/activityOrderResult.js') + '&orderNo=' + encodeURI(ret.body.orderNo), 'true', 1);
            } else if (res.body.type === 2) {
              this.$router.push({
                path: `/activityOrderInfo?orderId=${this.orderId}&actId=${this.activeID}&orderNo=${res.body.orderNo}`
              });

              // this.$router.push(`/activityOrderInfo/${this.orderId}`+'?actId='+this.activeID);
            }
          } else {
            util.showToast('暂无数据');
          }
        } else {
          util.showToast(res.res.msg);
        }
      });
    }
  }
};
</script>


<style lang="less" scoped>
@import "../../assets/css/common.less";

html,
body {
  min-height: 100vh;
  background: #fff;
}
.container{
  background:#fff;
}
.datetime-picker {
  height: 500px;
}
.noMess {
  p {
    margin-top: 200px;
    .fontSize(14px);
    text-align: center;
    color: @color6;
  }
}
.shop_list {
  background: #fff;
  margin-bottom: 138px;
  .main {
    margin-top: 20px;
  }
  .main_title {
    height: 66px;
    text-align: left;
    color: @color3;
    .fontSize(24px);
    line-height: 66px;

    margin: 10px 40px 0px 40px;
  }
  .inpBox {
    position: relative;
    padding-left: 40px;
    padding-right: 40px;
    padding-top: 20px;
    flex-direction: column;
  }
  .activeRadio {
    display:block;
    width:148px;
    height:56px;
    border-radius:4px;
    color: #333;
    .fontSize(14px);
    line-height: 56px;
    text-align: center;
    margin-right: 14px;
    border-radius:4px;
    border-color:#dadada;
  }

  .butn_radio {
    display:block;
    width:148px;
    height:56px;
    background:@color17;
    border-radius:4px;
    color: #fff;
    .fontSize(14px);
    line-height: 56px;
    text-align: center;
    margin-right: 14px;
    border-radius:4px;
    border-color:@color17;
  }

  .inpBox_title {
    height: 34px;
    margin-top: 60px;
    line-height: 34px;
    text-align: left;
    color: @color3;
    .fontSize(15px);
  }
  .butn_box_row1 {
    margin-top: 20px;
    display:flex;
    flex-direction: row;
  }

  .butn_name1 {
    height: 84px;
    line-height: 84px;
    width: 670px;
    border: none;
    .fontSize(14px);
    color: @color9;
    .textOver();
  }

  .butn_name {
    height: 84px;
    line-height: 84px;
    width: 670px;
    border: none;
    .fontSize(14px);
    color: @color3;
    .textOver();
  }
  .inpBox1_text {
    height: 84px;
    width: 670px;
    border: none;
    color: @color3;
    .fontSize(15px);
  }
  .inpBox2_text {
    height: 240px;
    border: none;
    padding: 20px 0;
    color: @color3;
    .fontSize(15px);
  }
  .content_1_line {
    height: .015rem;
    background-color: #eaeaea;
    position: absolute;
    bottom: 0;
    left: 40px;
    right:40px;
  }
  /*  */
  .inpBox3 {
    position: fixed;
    left: 0;
    bottom: 0;
    padding: 40px 28px;
  }
  .btnX {
    padding-bottom: 138px;
  }
  .inpBox3_text {
    height: 76px;
    width: 694px;
    border-radius: 8px;
    background-color: #0087ff;
    line-height: 76px;
    text-align: center;
    .fontSize(15px);
    color: #ffffff;
  }
}
.button {
  .btn_bm {
    height: 76px;
    width:100%;
    display:block;
    .btn();
    border-radius: 4px;
    text-align: center;
    line-height: 76px;
    .fontSize(16px);
    display: block;
  }

  .btn_bm_gray {
    height: 76px;
    width:100%;
    display:block;
    .btn();
    border-radius: 4px;
    text-align: center;
    line-height: 76px;
    .fontSize(16px);
    display: block;
    background: @colord6;
  }
}

/* 下拉、上拉提示信息 */
.top-tip {
  position: absolute;
  top: -40px;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #555;
}

.bottom_tip {
  width: 100%;
  height: 100px;
  line-height: 100px;
  text-align: center;
  color: #666;
  .fontSize(14px);
}

</style>